














































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { cloneDeep, flattenDeep } from 'lodash';

import { ZenEllipsis } from 'zenComponents';
import ZenButton from '@reciprocity/button';
import { keysToSnake } from '@/utils';
import ZenTable from '@/components/listing/ZenTable.vue';

export default Vue.extend({
  name: 'ContentTab',
  components: {
    ZenEllipsis,
    ZenButton,
    ZenTable,
  },
  data() {
    return {
      registersColumns: [
        { key: 'showDetails', label: ' ', presenter: 'TreeViewToggle' },
        { key: 'selected', label: ' ' },
        { key: 'title', label: 'Title' },
        { key: 'description', label: 'Description' },
      ],
      groupsColumns: [{ key: 'showDetails', presenter: 'TreeViewToggle' }, { key: 'selected' }, { key: 'group' }],
      objectsColumns: [{ key: 'selected' }, { key: 'title' }, { key: 'description' }],
      registers: [],
      loading: <boolean>true,
      addingRegister: false,
      selection: [],
    };
  },
  watch: {
    registers: {
      handler(): Object {
        this.selection = this.registers
          .map(reg => ({
            registerId: reg.id,
            objectIds: flattenDeep(reg.groups.map(g => g.objects.filter(o => o.selected).map(o => o.id))),
          }))
          .filter(r => !!r.objectIds.length);
      },
      deep: true,
    },
  },
  async created() {
    try {
      let registers = await this.request({
        route: 'riskRegisters',
        defaultErrorHandler: false,
      });
      // Fill in the data that zenObjectTable needs to show tree structure:
      let treeData = {
        rowDetails: {
          active: false,
        },
        hasMappedObjects: true, // todo: remove this
      };
      registers.forEach(a => {
        a.selected = false;
        a.indeterminate = false;
        a.meta = cloneDeep(treeData);
        // Groups can be opened only manually (on radio select):
        a.meta.hasMappedObjects = true;
        if (a.groups) {
          a.groups.forEach(b => {
            b.meta = cloneDeep(treeData);
            b.selected = false;
            b.indeterminate = false;

            if (b.objects) {
              b.objects.forEach(c => (c.selected = false));
            }
          });
        }
      });
      this.registers = registers;
    } catch (e) {
      this.showAlert({
        type: 'error',
        message: 'Failed to load Risk Registers',
      });
    } finally {
      this.loading = false;
      this.$emit('loaded');
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      showModal: 'modals/show',
      request: 'request',
    }),
    async addRegister() {
      const isConfirmed = await this.confirmRegisterAdding();
      if (isConfirmed) {
        this.addingRegister = true;
        try {
          const resp = await this.request({
            method: 'post',
            route: 'riskAddContent',
            data: keysToSnake(this.selection),
          });
          if (resp.created > 0) {
            this.showAlert({
              type: 'success',
              message: `Objects have been added. <br><a href="${resp.url}">${resp.created} Risk objects created.`,
            });
          } else {
            this.showAlert({
              type: 'warning',
              message: `These objects were already added.`,
            });
          }
        } catch (e) {
          // Error caught in request
        }
        this.addingRegister = false;
      }
    },
    async confirmRegisterAdding() {
      let isConfirmed = false;
      try {
        isConfirmed = await this.showModal({
          type: 'GenericConfirm',
          data: {
            title: 'Confirm changes',
            okTitle: 'Add',
            message: 'The selected Risk Register will be added.',
          },
        });
      } catch (e) {
        // User closed modal
      }
      return isConfirmed;
    },
    toggleRowDetails(props): void {
      props.row.meta.rowDetails.active = !props.row.meta.rowDetails.active;
      this.$forceUpdate();
    },
    registerCheckClicked(reg) {
      this.toggleRegisterGroups(reg);
    },
    groupCheckClicked(group) {
      this.toggleGroupObjects(group);
    },
    objectRowClicked(data) {
      data.row.selected = !data.row.selected;
      this.updateCheckboxes();
    },
    toggleRegisterGroups(reg) {
      let allSelected = !reg.groups.some(a => a.objects.some(b => !b.selected));
      reg.groups.forEach(group => group.objects.forEach(b => (b.selected = !allSelected)));
      this.updateCheckboxes();
    },
    toggleGroupObjects(group) {
      let allSelected = !group.objects.some(a => !a.selected);
      group.objects.forEach(a => (a.selected = !allSelected));
      this.updateCheckboxes();
    },
    updateCheckboxes() {
      function updateCheckbox(obj, childProp) {
        // Determin what kind of checkbox should we draw:
        let someDeselected = obj[childProp].some(a => !a.selected || a.indeterminate);
        let someSelected = obj[childProp].some(a => a.selected || a.indeterminate);
        obj.selected = !someDeselected;
        obj.indeterminate = someSelected && someDeselected;
      }

      // Update group checkboxes:
      this.registers.forEach(register => {
        register.groups.forEach(a => updateCheckbox(a, 'objects'));
      });

      // Update register checkboxes:
      this.registers.forEach(a => updateCheckbox(a, 'groups'));
      this.$forceUpdate();
    },
  },
});
